import dayjs from 'dayjs';

import { useAuth } from 'hooks/useAuth';

import { Badge, Group, Stack, Text, Card } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { breakpoints } from 'styles/theme.variables';
import SourceAvatar from 'components/SourceAvatar';

interface RawDetail {
  result: string;
}

interface PublishResultItemProps {
  result: {
    result: string;
    timestamp: string | number | Date;
    detail?: string;
    rawDetail?: RawDetail | null;
    integrationName: string;
  };
}

export default function PublishResultItem({ result }: PublishResultItemProps) {
  const { isInternalUser, isImpersonating } = useAuth();
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.maxMobile})`, undefined, {
    getInitialValueInEffect: false,
  });

  function formatTimestamp(timestamp: string | number | Date) {
    return dayjs(timestamp).format('MMM D, YYYY [at] h:mma');
  }
  const isFailedResult = result.result === 'failed';

  return (
    <Group gap="xs" wrap={isMobile ? 'wrap' : 'nowrap'} align="flex-start">
      <SourceAvatar source={result.integrationName} />
      <Stack gap="xs2">
        <Text>{formatTimestamp(result.timestamp)}</Text>
        {isFailedResult && (
          <>
            <Text>{result.detail}</Text>
            {(isInternalUser || isImpersonating) && result.rawDetail && (
              <Card bg="var(--surface-secondary)" radius="xs2" p="xs">
                <Text>{result.rawDetail?.result}</Text>
              </Card>
            )}
          </>
        )}
      </Stack>
      <Badge
        variant={isFailedResult ? 'caution' : 'success'}
        style={{ overflow: 'visible' }}
        size="xs"
      >
        {isFailedResult ? 'fail' : 'success'}
      </Badge>
    </Group>
  );
}
